import React from 'react';
import { motion } from 'framer-motion';
import { CrystalIcon } from './CrystalIcon';
import { DAILY_HIT_GOAL } from './oathTheme';

const sparks = (n) => Array.from({ length: n }, (_, i) => {
  const a = (i / n) * Math.PI * 2;
  const r = 110 + (i % 4) * 30;
  return { x: Math.cos(a) * r, y: Math.sin(a) * r, d: (i % 3) * 0.04 };
});

/* Gold coin drop + light burst. Bigger "RUSH" combo once the daily goal is hit. */
export const GratitudeRush = ({ count, label, kind, color }) => {
  const combo = count >= DAILY_HIT_GOAL;
  const list = sparks(combo ? 28 : 14);
  return (
    <motion.div className="fixed inset-0 z-[300] pointer-events-none flex items-center justify-center"
      initial={{ opacity: 1 }} animate={{ opacity: 0 }} transition={{ delay: combo ? 1.3 : 0.9, duration: 0.5 }} data-testid="gratitude-rush">
      <div className="absolute inset-0" style={{ background: 'radial-gradient(circle, rgba(3,3,6,0.75), rgba(3,3,6,0.55))' }} />
      <motion.div className="absolute w-64 h-64 rounded-full" initial={{ scale: 0.2, opacity: 0.9 }} animate={{ scale: combo ? 3.6 : 2.4, opacity: 0 }} transition={{ duration: 1.1, ease: 'easeOut' }}
        style={{ background: `radial-gradient(circle, rgba(255,233,160,0.8), ${color}55 45%, transparent 70%)` }} />
      {list.map((s, i) => (
        <motion.span key={i} className="absolute w-1.5 h-1.5 rounded-full" initial={{ x: 0, y: 0, opacity: 1, scale: 1.5 }} animate={{ x: s.x, y: s.y, opacity: 0, scale: 0.4 }}
          transition={{ duration: 0.9, delay: s.d, ease: 'easeOut' }} style={{ background: i % 2 ? '#FFE9A0' : color, boxShadow: '0 0 10px #FFE9A0' }} />
      ))}
      <motion.div className="relative text-center" initial={{ y: -260, scale: 0.6 }} animate={{ y: -20, scale: 1 }} transition={{ type: 'spring', stiffness: 240, damping: 13 }}>
        <motion.div className="mx-auto w-24 h-24 rounded-full flex items-center justify-center" animate={{ rotateY: [0, 360] }} transition={{ duration: 0.8 }}
          style={{ background: 'radial-gradient(circle, rgba(255,233,160,0.35), transparent 70%)', filter: 'drop-shadow(0 0 24px rgba(255,212,92,0.8))' }}><CrystalIcon kind={kind} size={84} /></motion.div>
        <p className="font-['Outfit'] text-4xl font-semibold mt-3" style={{ color: '#FFE9A0', textShadow: '0 0 24px rgba(212,175,55,0.9)' }}>{combo && count > DAILY_HIT_GOAL ? `RUSH ×2 · +10` : combo ? 'RUSH UNLOCKED' : '+5'}</p>
        <p className="font-['Outfit'] text-[11px] tracking-[0.3em] uppercase mt-1" style={{ color }}>{label} · banked</p>
      </motion.div>
    </motion.div>
  );
};

export default GratitudeRush;
